export const Grain = () => <div className="grain-layer" aria-hidden="true" />;
